export default __webpack_public_path__ + "static/headstand-bodycenter-2-02512f2b865ddff96e9c0d969904083e.jpg";